import { useContext, useState } from "react";
import Typography from "@common/components/Typography";
import { Box, Stack, Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";
import IconButton from "@common/components/IconButton";
import {
  ReducerContext,
  ReducerDispatchContext,
} from "@pages/Configuration/DeviceCatalog/context";
import { Add, Remove } from "@mui/icons-material";
import MappingListView from "./MappingListView";
import { properties } from "./MappingListView/colDef";

const MappingTabContent = () => {
  const {
    device,
    mappingEntries,
    mappingInherit,
    canEdit,
    canAccessExtendedPropertyMapping,
  } = useContext(ReducerContext);
  const dispatch = useContext(ReducerDispatchContext);
  const { t } = useTranslation();
  const count = mappingEntries.length;
  const [entrySelected, setEntrySelected] = useState<number[]>([]);

  const handleAddButton = () => dispatch({ type: "addMappingEntry" });

  const handleDeleteButton = () =>
    dispatch({
      type: "removeMappingEntry",
      value: (mappingEntries ?? []).filter((_, index) =>
        entrySelected.includes(index)
      ),
    });

  const handleSelected = (selected: number[]) => {
    if (entrySelected.length != selected.length) {
      setEntrySelected(selected);
    }
  };
  return (
    <>
      <Stack
        direction="row"
        sx={{
          justifyContent: "space-between",
        }}
      >
        <Typography sx={{ m: 2 }} size="medium">
          {`${device.manufacturer} ${device.model} - ${t(
            "Mapped Extended Properties"
          )} (${count ?? 0})`}
        </Typography>
        {!mappingInherit && canAccessExtendedPropertyMapping && (
          <Stack direction="row" spacing={2}>
            <Box>
              <Tooltip title={t("Add Mapping")} arrow>
                <span>
                  <IconButton
                    size="small"
                    color="inherit"
                    onClick={() => handleAddButton()}
                    disabled={
                      !canEdit ||
                      mappingEntries.length == properties.length ||
                      !canAccessExtendedPropertyMapping
                    }
                  >
                    <Add />
                  </IconButton>
                </span>
              </Tooltip>
            </Box>
            <Box>
              <Tooltip
                title={
                  entrySelected.length === 1
                    ? t("Delete Mapping")
                    : t("Delete Mappings")
                }
                arrow
              >
                <span>
                  <IconButton
                    size="small"
                    color="inherit"
                    onClick={() => handleDeleteButton()}
                    disabled={
                      !canEdit ||
                      entrySelected.length === 0 ||
                      !canAccessExtendedPropertyMapping
                    }
                  >
                    <Remove />
                  </IconButton>
                </span>
              </Tooltip>
            </Box>
          </Stack>
        )}
      </Stack>
      <MappingListView setMappingSelected={handleSelected} />
    </>
  );
};

export default MappingTabContent;
